<script context="module" lang="ts">
  export enum Theme {
    DARK_ON_LIGHT = 'darkOnLight',
    LIGHT_ON_DARK = 'lightOnDark'
  }
</script>

<script lang="ts">
  import { BusinessUnit } from '$lib/careers/types';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  export let businessUnit: BusinessUnit;
  export let monochrome = false;

  export let theme: Theme = Theme.DARK_ON_LIGHT;

  const brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);

  let filename = '';

  $: {
    const useLight = theme === Theme.LIGHT_ON_DARK;
    if (monochrome) {
      switch (businessUnit) {
        case BusinessUnit.AFTERPAY:
          filename = useLight ? 'Afterpay_Mono_White.svg' : 'Afterpay_Mono_Black.svg';
          break;
        case BusinessUnit.BLOCK:
          filename = useLight
            ? brandReskinEnabled
              ? 'Block_Reskin_Color_Light.svg'
              : 'Block_Color_Light.png'
            : brandReskinEnabled
              ? 'Block_Reskin_Color_Dark.svg'
              : 'Block_Color_Dark.png';
          break;
        case BusinessUnit.SQUARE:
          filename = useLight ? 'Square_Mono_White.svg' : 'Square_Mono_Black.svg';
          break;
        case BusinessUnit.CASHAPP:
          filename = useLight ? 'Cash_Mono_White.svg' : 'Cash_Mono_Black.svg';
          break;
        case BusinessUnit.TIDAL:
          filename = useLight ? 'TIDAL_Mono_White.svg' : 'TIDAL_Mono_Black.svg';
          break;
        case BusinessUnit.SPIRAL:
          filename = useLight ? 'Spiral_Mono_White.svg' : 'Spiral_Mono_Black.svg';
          break;
        case BusinessUnit.PROTO:
          filename = useLight ? 'Proto_Mono_White.svg' : 'Proto_Mono_Black.svg';
          break;
      }
    } else {
      switch (businessUnit) {
        case BusinessUnit.AFTERPAY:
          filename = useLight ? 'Afterpay_Mono_White.svg' : 'Afterpay_Mono_Black.svg';
          break;
        case BusinessUnit.BLOCK:
          filename = useLight
            ? brandReskinEnabled
              ? 'Block_Reskin_Color_Light.svg'
              : 'Block_Color_Light.png'
            : brandReskinEnabled
              ? 'Block_Reskin_Color_Dark.svg'
              : 'Block_Color_Dark.png';
          break;
        case BusinessUnit.SQUARE:
          filename = useLight ? 'Square_Mono_White.svg' : 'Square_Mono_Black.svg';
          break;
        case BusinessUnit.CASHAPP:
          filename = useLight ? 'Cash_Mono_White.svg' : 'Cash_Mono_Black.svg';
          break;
        case BusinessUnit.TIDAL:
          filename = useLight ? 'TIDAL_Mono_White.svg' : 'TIDAL_Mono_Black.svg';
          break;
        case BusinessUnit.SPIRAL:
          filename = useLight ? 'Spiral_Mono_White.svg' : 'Spiral_Mono_Black.svg';
          break;
        case BusinessUnit.PROTO:
          filename = useLight ? 'Proto_Mono_White.svg' : 'Proto_Mono_Black.svg';
          break;
      }
    }
  }
</script>

<img src={`/bu_logos/horizontal/${filename}`} alt={businessUnit} />

<style>
  img {
    height: 100%;
  }
</style>
